import React from "react";
import Select from "react-select";
import { RaisedButton, TextField } from "material-ui";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import DateTimeUtil from "../../utils/DateTimeUtil";

import BoxOfficeScheduleView from "./schedule-views/box-office-schedule-view.jsx";
import CustomLedgerScheduleView from "./schedule-views/custom-ledger-schedule-view.jsx";
import RecurringPassRenewalScheduleView from "./schedule-views/recurring-pass-renewal-schedule-view.jsx";
import ExpiredPassScheduleView from "./schedule-views/expired-pass-schedule-view.jsx";
import NewSubscriptionScheduleView from "./schedule-views/new-subscription-schedule-view.jsx";

class ScheduleWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedItem: null,
      selectedReport: null,
      selectedBuckets: [],
      selectedFilm: [],
      selectedFrequency: null,
      selectedTime: null,
      selectedDayOfWeek: null,
      recipientEmails: "",
      conditions: {},
      nickname: "",
      frequencyList: [
        { label: "Daily", value: "daily" },
        { label: "Weekdays (M-F)", value: "weekdays" },
        { label: "Weekly", value: "weekly" },
        { label: "Monthly", value: "monthly" }
      ],
      timeList: DateTimeUtil.getTimeList(),
      dayOfWeekList: DateTimeUtil.getDayOfWeekList(),
      childIsComplete: false
    };

    this.handleUpdateClick = this.handleUpdateClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.displayReportRangeInfo = this.displayReportRangeInfo.bind(this);
    this.handleScheduleViewChange = this.handleScheduleViewChange.bind(this);
    this.checkUpdateButtonIsDisabled =
      this.checkUpdateButtonIsDisabled.bind(this);
    this.makeScheduleWidgetView = this.makeScheduleWidgetView.bind(this);
    this.handleUpdateEvents = this.handleUpdateEvents.bind(this);
  }

  componentDidMount() {
    const item = this.props.item;
    //TODO: Handle "film" property
    this.setState({
      selectedItem: item.id,
      selectedReport: item.report_name,
      selectedFrequency: { value: item.frequency },
      selectedTime: { value: item.time },
      selectedDayOfWeek: item.day_of_week,
      recipientEmails: this.convertEmailsToString(item.recipient_emails),
      selectedBuckets: [
        item.event_bucket && item.event_bucket.length > 0
          ? item.event_bucket[0]._id
          : null
      ],
      selectedFilm: item.films
        ? item.films.map(film => ({ value: film._id, label: film.name }))
        : item.film ? [{ value: item.film._id, label: item.film.name }] : [],
      conditions: item.conditions ? item.conditions : null
    });
    // if editing an existing schedule, the item is assumed complete
    // at load time
    if (item.id) {
      this.setState({ childIsComplete: true });
    }
  }

  handleUpdateEvents(bucketId) {
    this.props.updateEvents(bucketId);
  }

  handleCloseClick() {
    this.props.close();
  }

  handleUpdateClick() {
    this.props.update({
      id: this.state.selectedItem,
      report_name: this.state.selectedReport,
      event_bucket: Array.isArray(this.state.selectedBuckets)
        ? this.state.selectedBuckets
        : [this.state.selectedBuckets],
      films: this.state.selectedFilm
        ? this.state.selectedFilm.map(film => ({
            name: film.label,
            id: film.value
          }))
        : [],
      conditions: this.state.conditions ? this.state.conditions : {},
      nickname: this.state.nickname ? this.state.nickname : "",
      frequency: this.state.selectedFrequency,
      time: this.state.selectedTime,
      day_of_week: this.state.selectedDayOfWeek,
      recipient_emails: this.convertEmailsToArray(this.state.recipientEmails)
    });
  }

  handleScheduleViewChange(updatedState, isComplete) {
    this.setState(updatedState);
    // Child Schedule View must return isComplete status in order for
    // ScheduleWidget to know if the Submit/Update button can be enabled
    this.setState({ childIsComplete: isComplete });
  }

  checkUpdateButtonIsDisabled() {
    if (
      this.state.childIsComplete === false ||
      this.state.selectedFrequency.value == null ||
      this.state.selectedTime.value == null ||
      this.state.recipientEmails === null ||
      this.state.recipientEmails.trim() === ""
    ) {
      return true;
    }

    if (
      this.state.selectedFrequency === "weekly" &&
      this.state.selectedDayOfWeek === null
    ) {
      return true;
    }

    return false;
  }

  displayReportRangeInfo() {
    let info = "";
    switch (this.state.selectedFrequency.value) {
      case "daily":
        info =
          "Delivers report data from 12:00 AM to 11:59 PM of the previous day.";
        break;
      case "weekdays":
        info =
          "Delivers report data from 12:00 AM to 11:50 PM of the previous day. On Mondays, delivers data from Friday to Sunday.";
        break;
      case "weekly":
        let now = moment();
        if (this.state.selectedDayOfWeek) {
          now.day(this.state.selectedDayOfWeek.value);
        }
        const lastDay = now.subtract(1, "days").format("ddd");
        const firstDay = now.subtract(6, "days").format("ddd");
        info =
          "Delivers report data from the previous 7 days (" +
          firstDay +
          " - " +
          lastDay +
          ").";
        break;
      case "monthly":
        info =
          "Delivers report data from the previous month on the 1st of the next month.";
        break;
      default:
        break;
    }
    return info;
  }

  convertEmailsToArray(value) {
    if (typeof value !== "string") {
      return [];
    } else {
      return this.state.recipientEmails.split(",").map(item => item.trim());
    }
  }

  convertEmailsToString(values) {
    return (values || []).join(", ");
  }

  getStyles() {
    return {
      widgetWrapper: {
        backgroundColor: "#eee",
        boxSizing: "border-box",
        padding: "30px",
        width: "100%",
        borderRadius: "1em"
      },
      widgetTitle: {
        float: "left",
        overflow: "visible",
        fontWeight: "bold",
        fontSize: "15px"
      },
      reportTypeWrapper: {
        clear: "both",
        float: "left",
        marginTop: "-5px"
      },
      emailInput: {
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        borderRadius: "3px",
        height: "20px",
        width: "60%",
        minWidth: "400px",
        fontSize: "13px",
        padding: "8px"
      },
      fieldLabel: {
        color: "#737373",
        fontWeight: "bold",
        marginBottom: 2
      }
    };
  }

  makeScheduleWidgetView(eventBucketList, filmList) {
    switch (this.state.selectedReport) {
      case "box_office_report":
        return (
          <BoxOfficeScheduleView
            item={this.props.item}
            eventBuckets={eventBucketList}
            films={filmList}
            update={this.handleScheduleViewChange}
          />
        );

      case "custom_ledger_report":
        return (
          <CustomLedgerScheduleView
            item={this.props.item}
            eventBuckets={eventBucketList}
            update={this.handleScheduleViewChange}
            events={this.props.events}
            updateEvents={this.handleUpdateEvents}
          />
        );

      case "recurring_pass_renewal_report":
        return (
          <RecurringPassRenewalScheduleView
            item={this.props.item}
            eventBuckets={eventBucketList}
            update={this.handleScheduleViewChange}
          />
        );

      case "expired_pass_report":
        return (
          <ExpiredPassScheduleView
            item={this.props.item}
            eventBuckets={eventBucketList}
            update={this.handleScheduleViewChange}
          />
        );

      case "new_subscription_report":
        return (
          <NewSubscriptionScheduleView
            item={this.props.item}
            eventBuckets={eventBucketList}
            update={this.handleScheduleViewChange}
          />
        );

      default:
        return null;
    }
  }

  render() {
    let { value, onChange, onBlur, placeholder, ...props } = this.props;

    const styles = this.getStyles();

    let timeList = this.state.timeList;
    let selectedTime =
      this.state.selectedTime && this.state.selectedTime.value
        ? this.state.selectedTime.value
        : null;

    const eventBuckets = this.props.buckets;
    let eventBucketList = [];
    if (eventBuckets) {
      eventBucketList = eventBuckets.map(e => {
        return { label: e.name, value: e.id };
      });
    }

    let filmList = [];
    if (this.state.selectedBuckets && this.state.selectedBuckets.length > 0) {
      let films = this.props.films;
      // filter "accident" unnamed films out
      films = films.filter(f => f.name);
      films = films.reduce((result, item) => {
        if (item.event_bucket === this.state.selectedBuckets[0]) {
          result.push(item);
        }
        return result;
      }, []);

      filmList = films.map(f => {
        return { label: f.name, value: f.id };
      });

      const bucket = this.props.buckets.find(
        element => element.id === this.state.selectedBuckets[0]
      );

      const timezone = bucket ? bucket.timezone : "America/Los_Angeles"; //Intl.DateTimeFormat().resolvedOptions().timeZone;

      timeList = this.state.timeList.map(item => {
        let newItem = cloneDeep(item);
        newItem.label = newItem.label + " " + moment.tz(timezone).format("z");
        return newItem;
      });

      if (selectedTime) {
        const hourNum = selectedTime.substring(0, selectedTime.indexOf(":"));
        selectedTime = moment()
          .utc()
          .set("hour", parseInt(hourNum, 10))
          .tz(timezone)
          .format("HH:00");
      }
    }

    return (
      <div style={styles.widgetWrapper}>
        <div style={styles.widgetTitle}>
          {this.props.isNew
            ? "Schedule Automated Report"
            : "Edit Automated Report"}
        </div>
        <div
          style={{
            float: "right"
          }}
        >
          <RaisedButton label="X" onTouchTap={this.handleCloseClick} />
        </div>
        <div style={styles.reportTypeWrapper}>
          <div style={styles.fieldLabel}>Report Type</div>
          <Select
            clearable={false}
            autosize={false}
            multi={false}
            value={this.state.selectedReport}
            placeholder="Select a report..."
            options={[
              { label: "Box Office Report by Film", value: "box_office_report" },
              { label: "Ledger Transaction Report", value: "custom_ledger_report" },
              {
                label: "Recurring Pass Renewal Report",
                value: "recurring_pass_renewal_report"
              },
              { label: "Expired Pass Report", value: "expired_pass_report" },
              {
                label: "New Subscription Report",
                value: "new_subscription_report"
              }
            ]}
            onChange={e => {
              this.setState({ selectedReport: e.value });
            }}
          />
        </div>
        {this.state.selectedReport ? (
          <div style={{ clear: "both", paddingTop: "10px" }}>
            <div style={styles.fieldLabel}>
              Recipient Emails (separated by commas)
            </div>
            <input
              value={this.state.recipientEmails}
              style={styles.emailInput}
              onChange={e => {
                this.setState({ recipientEmails: e.target.value });
              }}
            />
          </div>
        ) : null}
        {this.makeScheduleWidgetView(eventBucketList, filmList)}
        {this.state.selectedReport ? (
          <div>
            <div
              className="pull-left clear-both"
              style={{
                width: "200px",
                paddingTop: "10px"
              }}
            >
              <div style={styles.fieldLabel}>Frequency</div>
              <Select
                clearable={false}
                autosize={false}
                multi={false}
                placeholder="No frequency selected"
                value={
                  this.state.selectedFrequency
                    ? this.state.selectedFrequency.value
                    : null
                }
                options={this.state.frequencyList}
                onChange={value => {
                  this.setState({
                    selectedFrequency: value,
                    selectedDayOfWeek: null
                  });
                }}
              />
            </div>
            {this.state.selectedFrequency ? (
              this.state.selectedFrequency.value === "weekly" ? (
                <div
                  className="pull-left"
                  style={{
                    width: "200px",
                    paddingTop: "10px",
                    marginLeft: "25px"
                  }}
                >
                  <div style={styles.fieldLabel}>Day of Week</div>
                  <Select
                    clearable={false}
                    autosize={false}
                    multi={false}
                    placeholder="No day of week selected"
                    value={this.state.selectedDayOfWeek}
                    options={this.state.dayOfWeekList}
                    onChange={value => {
                      this.setState({ selectedDayOfWeek: value });
                    }}
                  />
                </div>
              ) : null
            ) : null}
            <div
              className="pull-left"
              style={{
                width: "150px",
                paddingTop: "10px",
                marginLeft: "25px"
              }}
            >
              <div style={styles.fieldLabel}>Delivery Time</div>
              <Select
                clearable={false}
                autosize={false}
                multi={false}
                placeholder="No time selected"
                value={selectedTime}
                options={timeList}
                onChange={value => {
                  let bucket;
                  if (
                    this.state.selectedBuckets &&
                    this.state.selectedBuckets.length > 0
                  ) {
                    bucket = this.props.buckets.find(
                      element => element.id === this.state.selectedBuckets[0]
                    );
                  }
                  const timezone = bucket
                    ? bucket.timezone
                    : "America/Los_Angeles"; //Intl.DateTimeFormat().resolvedOptions().timeZone;

                  const hourNum = value.value.substring(
                    0,
                    value.value.indexOf(":")
                  );
                  this.setState({
                    selectedTime: {
                      value: moment()
                        .set("hour", parseInt(hourNum, 10))
                        .tz(timezone)
                        .utc()
                        .format("HH:00")
                    }
                  });
                }}
              />
            </div>
            {this.state.selectedFrequency ? (
              <div
                style={{
                  clear: "both",
                  paddingTop: "10px",
                  color: "#555",
                  fontStyle: "italic"
                }}
              >
                {this.displayReportRangeInfo()}
              </div>
            ) : null}
          </div>
        ) : null}
        <div style={{ clear: "both", paddingTop: "20px" }}>
          <RaisedButton
            label="Schedule"
            onClick={this.handleUpdateClick}
            disabled={this.checkUpdateButtonIsDisabled()}
          />
        </div>
      </div>
    );
  }
}

export default ScheduleWidget;



// WEBPACK FOOTER //
// ./src/app/components/partials/schedule-widget.jsx